import React from 'react';

const SandTimer = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#FFF3DA" />
    <circle
      cx="22"
      cy="22"
      r="21"
      transform="matrix(-1 0 0 1 46 2)"
      stroke="#F5B900"
      strokeWidth="2"
      strokeDasharray="4 4"
    />
    <path
      d="M28.8606 29.555C28.8613 28.6346 28.6006 27.7329 28.109 26.9548C27.6173 26.1767 26.9148 25.5542 26.0832 25.1597V22.8406C26.9148 22.4461 27.6173 21.8236 28.109 21.0456C28.6006 20.2675 28.8613 19.3658 28.8606 18.4453H30.2493V17.0566H17.7509V18.4453H19.1396C19.1389 19.3658 19.3996 20.2675 19.8912 21.0456C20.3829 21.8236 21.0854 22.4461 21.917 22.8406V25.1597C21.0854 25.5542 20.3829 26.1767 19.8912 26.9548C19.3996 27.7329 19.1389 28.6346 19.1396 29.555H17.7509V30.9437H30.2493V29.555H28.8606ZM27.4719 18.4453C27.472 19.2457 27.1957 20.0215 26.6895 20.6415C26.1834 21.2615 25.4786 21.6876 24.6945 21.8477V24.0002H23.3057V21.8477C22.5216 21.6876 21.8168 21.2615 21.3107 20.6415C20.8045 20.0215 20.5282 19.2457 20.5283 18.4453H27.4719Z"
      fill="#F5B900"
    />
  </svg>
);

export default SandTimer;
